import {
  Arrows,
  Crystal,
  Discord,
  Heart,
  Leaves,
  Mana,
  Pickaxe,
  Ring,
  Rune,
  Shield,
  Sword,
  Tools,
  Wolf,
} from 'src/assets/images/level-dashboard'
import { ArcSvg } from 'src/assets/images'

export function getIcon(icon: string) {
  switch (icon) {
    case 'heart': {
      return {
        x: Heart,
      }
    }
    case 'leaves': {
      return {
        x: Leaves,
      }
    }
    case 'mana': {
      return {
        x: Mana,
      }
    }
    case 'pickaxe': {
      return {
        x: Pickaxe,
      }
    }
    case 'ring': {
      return {
        x: Ring,
      }
    }
    case 'shield': {
      return {
        x: Shield,
      }
    }
    case 'sword': {
      return {
        x: Sword,
      }
    }
    case 'tools': {
      return {
        x: Tools,
      }
    }
    case 'wolf': {
      return {
        x: Wolf,
      }
    }
    // TODO replace axe to rune in back-end, for educational content
    case 'axe': {
      return {
        x: Rune,
      }
    }
    case 'arrows': {
      return {
        x: Arrows,
      }
    }
    case 'discord': {
      return {
        x: Discord,
      }
    }
    case 'crystal': {
      return {
        x: Crystal,
      }
    }
    default: {
      return {
        x: ArcSvg,
      }
    }
  }
}
